import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider";
import { AcceptInvitationPage } from "./pages/AcceptInvitationPage";
import { AccountingPage } from "./pages/AccountingPage";
import { AccountingPurchasesPage } from "./pages/AccountingPurchasesPage";
import { AccountingJournalPage } from "./pages/AccountingJournalPage";
import { AppShell } from "./components/AppShell";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { ModuleRoute } from "./components/ModuleRoute";
import { OrganizationProvider } from "./organization/OrganizationProvider";
import { AssetsPage } from "./pages/AssetsPage";
import { BankReconciliationPage } from "./pages/BankReconciliationPage";
import { AuditPage } from "./pages/AuditPage";
import { CatalogPage } from "./pages/CatalogPage";
import { ClientsPage } from "./pages/ClientsPage";
import { CustomerDetailPage } from "./pages/CustomerDetailPage";
import { DashboardPage } from "./pages/DashboardPage";
import { FiscalPage } from "./pages/FiscalPage";
import { InventoryPage } from "./pages/InventoryPage";
import { InventoryDetailPage } from "./pages/InventoryDetailPage";
import { ImportsPage } from "./pages/ImportsPage";
import { ImportDetailPage } from "./pages/ImportDetailPage";
import { LoginPage } from "./pages/LoginPage";
import { MastersPage } from "./pages/MastersPage";
import { QuotationsPage } from "./pages/QuotationsPage";
import { QuotationDetailPage } from "./pages/QuotationDetailPage";
import { ReportsPage } from "./pages/ReportsPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { PurchasesPage } from "./pages/PurchasesPage";
import { PurchaseDetailPage } from "./pages/PurchaseDetailPage";
import { SalesPage } from "./pages/SalesPage";
import { SaleDetailPage } from "./pages/SaleDetailPage";
import { ServiceApprovalPage } from "./pages/ServiceApprovalPage";
import { ServiceOrderDetailPage } from "./pages/ServiceOrderDetailPage";
import { ServiceTrackingPage } from "./pages/ServiceTrackingPage";
import { SettingsPage } from "./pages/SettingsPage";
import { SuperAdminPage } from "./pages/SuperAdminPage";
import { SupplierDetailPage } from "./pages/SupplierDetailPage";
import { TreasuryPage } from "./pages/TreasuryPage";
import { WorkshopPage } from "./pages/WorkshopPage";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <OrganizationProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route
              path="/accept-invitation"
              element={<AcceptInvitationPage />}
            />
            <Route
              path="/service-approval"
              element={<ServiceApprovalPage />}
            />
            <Route
              path="/seguimiento/:token"
              element={<ServiceTrackingPage />}
            />

            <Route element={<ProtectedRoute />}>
              <Route element={<AppShell />}>
                <Route index element={<DashboardPage />} />
                <Route path="/cotizaciones" element={<ModuleRoute moduleKey="quotations"><QuotationsPage /></ModuleRoute>} />
                <Route path="/cotizaciones/:quotationId" element={<ModuleRoute moduleKey="quotations"><QuotationDetailPage /></ModuleRoute>} />
                <Route path="/ventas" element={<ModuleRoute moduleKey="sales"><SalesPage /></ModuleRoute>} />
                <Route path="/compras" element={<ModuleRoute moduleKey="purchases"><PurchasesPage /></ModuleRoute>} />
                <Route path="/compras/:purchaseId" element={<ModuleRoute moduleKey="purchases"><PurchaseDetailPage /></ModuleRoute>} />
                <Route path="/proveedores/:supplierId" element={<ModuleRoute moduleKey="purchases"><SupplierDetailPage /></ModuleRoute>} />
                <Route path="/ventas/:saleId" element={<ModuleRoute moduleKey="sales"><SaleDetailPage /></ModuleRoute>} />
                <Route path="/catalogo" element={<ModuleRoute moduleKey="catalog"><CatalogPage /></ModuleRoute>} />
                <Route path="/maestros" element={<ModuleRoute moduleKey="catalog"><MastersPage /></ModuleRoute>} />
                <Route path="/taller" element={<ModuleRoute moduleKey="workshop"><WorkshopPage /></ModuleRoute>} />
                <Route
                  path="/taller/:orderId"
                  element={<ModuleRoute moduleKey="workshop"><ServiceOrderDetailPage /></ModuleRoute>}
                />
                <Route path="/inventario" element={<ModuleRoute moduleKey="inventory"><InventoryPage /></ModuleRoute>} />
                <Route path="/inventario/:catalogItemId" element={<ModuleRoute moduleKey="inventory"><InventoryDetailPage /></ModuleRoute>} />
                <Route path="/importaciones" element={<ModuleRoute moduleKey="purchases"><ImportsPage /></ModuleRoute>} />
                <Route path="/importaciones/:importId" element={<ModuleRoute moduleKey="purchases"><ImportDetailPage /></ModuleRoute>} />
                <Route path="/clientes" element={<ModuleRoute moduleKey="crm"><ClientsPage /></ModuleRoute>} />
                <Route path="/clientes/:customerId" element={<ModuleRoute moduleKey="crm"><CustomerDetailPage /></ModuleRoute>} />
                <Route path="/activos" element={<ModuleRoute moduleKey="crm"><AssetsPage /></ModuleRoute>} />
                <Route path="/contabilidad" element={<ModuleRoute moduleKey="accounting"><AccountingPage /></ModuleRoute>} />
                <Route path="/contabilidad/compras-recibidas" element={<ModuleRoute moduleKey="accounting"><AccountingPurchasesPage /></ModuleRoute>} />
                <Route path="/contabilidad/asientos" element={<ModuleRoute moduleKey="accounting"><AccountingJournalPage /></ModuleRoute>} />
                <Route path="/tesoreria" element={<ModuleRoute moduleKey="accounting"><TreasuryPage /></ModuleRoute>} />
                <Route path="/conciliacion-bancaria" element={<ModuleRoute moduleKey="accounting"><BankReconciliationPage /></ModuleRoute>} />
                <Route path="/auditoria" element={<ModuleRoute moduleKey="accounting"><AuditPage /></ModuleRoute>} />
                <Route path="/reportes" element={<ModuleRoute moduleKey="accounting"><ReportsPage /></ModuleRoute>} />
                <Route path="/fiscal" element={<ModuleRoute moduleKey="accounting"><FiscalPage /></ModuleRoute>} />
                <Route path="/configuracion" element={<SettingsPage />} />
                <Route path="/super-admin" element={<SuperAdminPage />} />
              </Route>
            </Route>
          </Routes>
        </OrganizationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
